import { PostgrestSingleResponse } from '@supabase/supabase-js';
import { supabase } from '../../../../supabaseConfig';
import { IVwMovimentacoesRecentes } from '../../../types/views/IVwMovimentacoesRecentes';

/**
 * View para movimentações recentes
 * Corresponde à view 'vw_movimentacoes_recentes' no banco de dados
 */
export class ViewMovimentacoesRecentes {
     protected client = supabase;
     protected tableName = 'vw_movimentacoes_recentes' as const;

     /**
      * Lista movimentações recentes (últimos 30 dias)
      */
     async getMovimentacoesRecentes(organizationId: number, limite: number = 50): Promise<PostgrestSingleResponse<IVwMovimentacoesRecentes[]>> {

          return await this.client
               .from(this.tableName)
               .select('*')
                 .eq('fk_id_organizacao', organizationId)
               .order('data_movimentacao', { ascending: false })
               .limit(limite);
     }

     /**
      * Movimentações por tipo
      */
     async getMovimentacoesPorTipo(organizationId: number, tipoMovimentacao: 'credito' | 'debito'): Promise<PostgrestSingleResponse<IVwMovimentacoesRecentes[]>> {
          
          console.log('🔄 Buscando movimentações por tipo:', tipoMovimentacao, 'para organização:', organizationId);

          return await this.client
               .from(this.tableName)
               .select('*')
                 .eq('fk_id_organizacao', organizationId)
               .eq('tipo_movimentacao', tipoMovimentacao)
               .order('data_movimentacao', { ascending: false });
     }

     /**
      * Movimentações de uma pessoa específica
      * Filtra pela coluna 'fk_id_pessoa' da view vw_movimentacoes_recentes
      */
     async getMovimentacoesPorPessoa(organizationId: number, pessoaId: number): Promise<PostgrestSingleResponse<IVwMovimentacoesRecentes[]>> {
          console.log('🔄 Buscando movimentações para pessoaId:', pessoaId, 'na organização:', organizationId);

          return await this.client
               .from(this.tableName)
               .select('*')
                     .eq('fk_id_organizacao', organizationId)
                     .eq('fk_id_pessoa', pessoaId)
               .order('data_movimentacao', { ascending: false });
     }

     /**
      * Movimentações por período
      */
     async getMovimentacoesPorPeriodo(organizationId: number, dataInicio: string, dataFim: string): Promise<PostgrestSingleResponse<IVwMovimentacoesRecentes[]>> {


          return await this.client
               .from(this.tableName)
               .select('*')
                 .eq('fk_id_organizacao', organizationId)
               .gte('data_movimentacao', dataInicio)
               .lte('data_movimentacao', dataFim)
               .order('data_movimentacao', { ascending: false });
     }

     /**
      * Movimentações por origem
      */
     async getMovimentacoesPorOrigem(organizationId: number, tipoOrigem: string): Promise<PostgrestSingleResponse<IVwMovimentacoesRecentes[]>> {
         
          
          return await this.client
               .from(this.tableName)
               .select('*')
                 .eq('fk_id_organizacao', organizationId)
               .eq('tipo_origem', tipoOrigem)
               .order('data_movimentacao', { ascending: false });
     }

     /**
      * Total de movimentações por tipo
      */
     async getTotalPorTipo(organizationId: number): Promise<{
          total_creditos: number;
          total_debitos: number;
          saldo_liquido: number;
     }> {
         console.log('🔄 Calculando totais por tipo para organização:', organizationId);

          // Buscar todas as movimentações da organização
          const { data: movimentacoes } = await this.client
               .from(this.tableName)
               .select('valor, tipo_movimentacao')
                 .eq('fk_id_organizacao', organizationId);

          if (!movimentacoes) {
               return {
                    total_creditos: 0,
                    total_debitos: 0,
                    saldo_liquido: 0
               };
          }

          // Calcular totais usando JavaScript
          const total_creditos = movimentacoes
               .filter(mov => mov.tipo_movimentacao === 'credito')
               .reduce((sum, mov) => sum + (mov.valor || 0), 0);

          const total_debitos = movimentacoes
               .filter(mov => mov.tipo_movimentacao === 'debito')
               .reduce((sum, mov) => sum + (mov.valor || 0), 0);

          const resultado = {
               total_creditos,
               total_debitos,
               saldo_liquido: total_creditos - total_debitos
          };

          console.log('✅ Totais calculados:', resultado);
          
          return resultado;
     }

     /**
      * Limpar cache (útil para testes ou quando organizações/pessoas são alteradas)
      */
     clearCache(): void {
          console.log('🧹 Cache de ViewMovimentacoesRecentes limpo');
     }
}

export const viewMovimentacoesRecentes = new ViewMovimentacoesRecentes();
